export default function SchematicDirective() {
  return {
    template: require('./schematic.html'),
    scope: {
      customerId: '=',
      assessmentId: '=',
      schematic: '=',
      isEditable: '=',
      deleteCallback: '&',
      tooltipAppendToSelector: '@',
      schematicCount: '@',
    },
    controller: 'SchematicController',
    controllerAs: 'schematicVM',
    bindToController: true,
    replace: true,
  };
}
